import React, { useEffect } from 'react';
import { StatusWidgetState } from '@kemu-io/kemu-core/types';
import Icon from '@ant-design/icons';
import {
	InputName,
	getDefaultState,
} from '@kemu-io/kemu-core/widgets/status/index.js';
import { DataType } from '@kemu-io/hs-types';
import {
  GateUI,
	GateUIProps,
  GetPortsInformationFunction
} from '../index.js';
import styles from './status.module.css';
import TextInput from '@components/WidgetsComponents/TextInput/TextInput';
import useReactiveWidgetState from '@hooks/useReactiveWidgetState';
import GateIcon from '@components/gateIcon/gateIcon';
import useTranslation from '@hooks/useTranslation';
import { ReactComponent as StatusWidgetIcon } from '@src/assets/img/gates/status-widget.svg';
import statusManager from '@kemu-io/kemu-core/common/managers/statusManager.js';

type Props = GateUIProps


const StatusWidget = (props: Props) => {
  const { recipeId, thingRecipeId, info } = props;
  const [state, setState] = useReactiveWidgetState<StatusWidgetState>(recipeId, thingRecipeId, info.id);
  const t = useTranslation('Widget.Status');

	const fixedState = {
		...getDefaultState(),
		...state
	};

  const updateName = (name: string) => {
    const oldName = fixedState.name;
    
    setState((s) => ({
      ...s,
      name,
    }));

    // Update the status name in the status manager if the name has changed
    if (name && name !== oldName) {
      statusManager.updateStatusName({
        newName: name,
        statusWidgetId: info.id,
      });
    }
  };

  /**
   * Listens for status name changes for this specific widget
   */
  useEffect(() => {
    return statusManager.onStatusNameChange(info.id, (config) => {
      setState((s) => ({ ...s, name: config.newName }));
    });
  }, [info.id]);

  return (
    <div className={styles.InputWrapper}>
      <TextInput
        value={fixedState.name}
        placeholder={t('Placeholder')}
        onChange={(e) => updateName(e.currentTarget.value)}
      />
    </div>
  );
};

/** Icon to be added to the bar */
const GateBarIcon = (): React.JSX.Element => {
	return (
		<GateIcon icon={<Icon component={StatusWidgetIcon} />}/>
	);
};


const getPortsInformation: GetPortsInformationFunction = (state, widgetInfo) => {

	return {
		inputs: [{
      name: InputName,
      type: DataType.Anything,
      position: 'Left',
    }],
		outputs: [],
	};
};

export default {
	getPortsInformation,
  hasTitle: true,

	BarIcon: GateBarIcon,
	Element: StatusWidget,
	getGatesBarTitle: (intl) => intl.formatMessage({ id: 'Widget.Status.Title' }),
} as GateUI;
